import React, { useState } from 'react';

import { withStyles } from '@material-ui/core/styles';
import * as valid from 'utils/validators';
import { useBoolean } from 'utils/react';
import PaperForm from 'ui/form/PaperForm';
import SectionForm from 'ui/form/SectionForm';
import Fields from 'ui/form/FieldsForm';
import ButtonsForm from 'ui/form/ButtonsForm';
import DualListBox from 'ui/duallist/DualListBox';

import { withAppContext } from '../../../AppContext';

const CANCEL_ACTION = 'cancel.action';
const SAVE_ACTION = 'save.action';

const validateRules = valid.rules([
    valid.notEmpty('name'),
    valid.notEmpty('description'),
]);

const groupFormStyles = theme => ({
    list: { height: 450 },
});

export default withAppContext(RoleForm);

function RoleForm({
    app,
    mode,
    group,
    companies,
    loading,
    onSave = () => {},
    onCancel = () => {},
}) {
    const locking = useBoolean(false);
    const [errors, setErrors] = useState({});
    const [values, setValues] = useState(
        group
            ? {
                  ...group,
                  companies: group.companies.map(company => company.uuid),
              }
            : {
                  name: '',
                  description: '',
                  companies: [],
              }
    );
    const editable = mode === 'edit';
    const onAction = actionName => async () => {
        switch (actionName) {
            case SAVE_ACTION:
                const errors = await validateRules(values);
                if (Object.keys(errors).length) {
                    setErrors(errors);
                    app.on.scroll.notify();
                } else {
                    onSave({ ...values }).catch(setErrors);
                }
                break;
            case CANCEL_ACTION:
                onCancel();
                break;
            default:
                break;
        }
    };
    const onChange = name => value => {
        setValues({ ...values, ...{ [name]: value } });
    };
    const buttons = getActionsButtons({
        mode,
        loading,
        locking,
        onAction,
    });
    return (
        <PaperForm>
            <BodyForm
                editable={editable}
                values={values}
                errors={errors}
                companies={companies}
                onChange={onChange}
            />
            <ButtonsForm>{buttons}</ButtonsForm>
        </PaperForm>
    );
}

function BodyFormView({
    classes,
    editable,
    values,
    errors,
    companies,
    onChange,
}) {
    return (
        <React.Fragment>
            <SectionForm title="Company group details">
                <Fields.Text
                    label="Name"
                    error={errors.name}
                    value={values.name}
                    disabled={!editable}
                    onChange={onChange('name')}
                />
                <Fields.Text
                    label="Description"
                    error={errors.description}
                    value={values.description}
                    disabled={!editable}
                    onChange={onChange('description')}
                />
            </SectionForm>
            <SectionForm title="Companies">
                <DualListBox
                    disabled={!editable}
                    options={companies.map(r => ({
                        value: r.uuid,
                        label: r.name,
                    }))}
                    initialValue={values.companies}
                    sourceListHeaderName="Available"
                    destinationListHeaderName="Assigned"
                    destinationListError={false}
                    onChange={onChange('companies')}
                    className={classes.list}
                />
            </SectionForm>
        </React.Fragment>
    );
}

const BodyForm = withStyles(groupFormStyles)(BodyFormView);

function getActionsButtons({ mode, loading, locking, onAction }) {
    if (mode === 'edit') {
        return (
            <React.Fragment>
                <ButtonsForm.BackButton
                    label="Cancel"
                    onClick={onAction(CANCEL_ACTION)}
                    loading={loading}
                />
                <ButtonsForm.NextButton
                    label="Save"
                    onClick={onAction(SAVE_ACTION)}
                    loading={loading}
                    disabled={locking.value}
                />
            </React.Fragment>
        );
    }
    if (mode === 'view') {
        return (
            <ButtonsForm.NextButton
                label="OK"
                onClick={onAction(CANCEL_ACTION)}
                loading={loading}
            />
        );
    }
}
